import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CookieTypeComponent } from './cookie-type/cookie-type.component';
import { LegalDocumentLinksService } from '@app/core/legal-documents/legal-document-links.service';

@Component({
  selector: 'app-cookie-modal',
  imports: [
    TranslatePipe,
    ReactiveFormsModule,
    CookieTypeComponent,
  ],
  templateUrl: './cookie-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieModalComponent {
  private fb = inject(FormBuilder);
  protected modalRef = inject(BsModalRef);

  @Output() public saved = new EventEmitter<{ accepted: boolean }>();

  protected readonly legalDocumentLinks = inject(LegalDocumentLinksService);

  protected form = this.fb.group({
    functional: [{ value: true, disabled: true }],
    performance: [{ value: true, disabled: true }],
    marketing: [false],
  });

  protected accept(): void {
    this.form.controls.marketing.patchValue(true);
    setTimeout(() => {
      this.saved.emit({ accepted: true });
      this.modalRef.hide();
    }, 300);
  }

  protected save(): void {
    this.saved.emit({ accepted: !!this.form.controls.marketing.value });
    this.modalRef.hide();
  }
}
